export default () =>[
    {
        field: 'seq',
        width: 50,
        align: 'center',
        fixed: 'left',
        type: 'seq',
    },
    {
        field: 'col-opt',
        title: this.$l('INDEX.table_label_operation') || '操作',
        headerAlign: 'center',
        align: 'left',
        fixed: 'left',
        width: 110,
        slots: {
          default: 'opt',
    },
    },
    {
        field: 'supNo',
        align: 'left',
        minWidth: 100,
        title: this.$l('table_label_sup_no') || '厂家编码',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'supName',
        align: 'left',
        minWidth: 100,
        title: this.$l('table_label_sup_name') || '厂家名称',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    
    {
        field: 'contact',
        align: 'left',
        minWidth: 150,
        title: this.$l('table_label_contact') || '主要联系人',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'contactMobile',
        align: 'left',
        minWidth: 150,
        title: this.$l('table_label_contact_mobile') || '联系人手机',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'contactPhone',
        align: 'left',
        minWidth: 150,
        title: this.$l('table_label_contact_phone') || '固定电话',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'contactEmail',
        align: 'left',
        minWidth: 150,
        title: this.$l('table_label_contact_email') || '联系人Email',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'contactJob',
        align: 'left',
        minWidth: 150,
        title: this.$l('table_label_contact_job') || '联系人职务',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'supAddress',
        align: 'left',
        minWidth: 200,
        title: this.$l('table_label_sup_address') || '详细地址',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'custStatus',
        align: 'center',
        width: 100,
        title: this.$l('table_label_status') || '有效状态',
        slots: { default: 'status' },
        filters: [
          { label: '有效', value: 'Y' },
          { label: '无效', value: 'N' },
        ],
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'createBy',
        align: 'left',
        minWidth: 100,
        title: this.$l('table_label_create_by') || '创建人',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'createDate',
        align: 'center',
        minWidth: 150,
        title: this.$l('table_label_create_date') || '创建时间',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'modifyBy',
        align: 'left',
        minWidth: 100,
        title: this.$l('table_label_modify_by') || '修改人',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
    {
        field: 'modifyDate',
        align: 'center',
        minWidth: 150,
        title: this.$l('table_label_modify_date') || '修改时间',
        sortable: true,
        sortType: 'string',
        showHeaderOverflow: 'title',
        showOverflow: 'ellipsis',
    },
]